import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=268be2c4"
import script from "@/scripts/auth/component/register.js?vue&type=script&lang=js&external"
export * from "@/scripts/auth/component/register.js?vue&type=script&lang=js&external"
import style0 from "./Register.vue?vue&type=style&index=0&id=268be2c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports